import React from "react";
import DoctorsCard from "../cards/DoctorsCard";

// Style \\
import "../../assets/styles/sections/servicesDoctors.scss";
import "../../assets/styles/sections/doctors.scss";

// Swipper \\
import { Navigation, Pagination, Scrollbar, A11y } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";

const ServicesDoctors = () => {
  return (
    <section className="serviceDoctors">
      <div className="container">
        <div className="doctors_items">
          <div className="doctors_items_title">
            <p>Meet The</p>
            <h3>Team Members</h3>
          </div>

          <div className="card_box">
            <Swiper
              className="swipperHead"
              modules={[Navigation, Pagination, Scrollbar, A11y]}
              spaceBetween={170}
              slidesPerView={3}
              pagination={{ clickable: true }}
              onSlideChange={() => console.log("slide change")}
            >
              <SwiperSlide>
                <DoctorsCard />
              </SwiperSlide>
              <SwiperSlide>
                <DoctorsCard />
              </SwiperSlide>
              <SwiperSlide>
                <DoctorsCard />
              </SwiperSlide>
              <SwiperSlide>
                <DoctorsCard />
              </SwiperSlide>
              <SwiperSlide>
                <DoctorsCard />
              </SwiperSlide>
              <div className="dot">...</div>
            </Swiper>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesDoctors;
